import styled from 'styled-components';
import { StyledContainer as Container } from '../Container/container.styles';
import { StyledParagraph } from '../Typography/typography.styles';

export const StyledWrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.surface.primary};
  border-top: 1px solid ${({ theme }) => theme.palette.primary.gray};
  position: fixed;
  bottom: 0;
  width: 100%;
`;
export const StyledContainer = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
  padding-bottom: 8px;
`;
export const StyledText = styled(StyledParagraph)`
  margin: 0;

  & + * {
    margin: 0;
  }
`;
